import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import useFirebase from './Firebase';
import * as ROUTES from '../constants/routes';
import { TextField, makeStyles, Button, Grid } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: 200
    }
  }
}));

const PasswordForgetPage = () => (
  <div>
    <h1>PasswordForget</h1>
    <PasswordForgetForm />
  </div>
);

const PasswordForgetForm = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const firebase = useFirebase();

  const handleSubmit = e => {
    firebase
      .doPasswordReset(email)
      .then(() => {
        setEmail('');
        setError(null);
      })
      .catch(setError);
    e.preventDefault();
  };

  const isInvalid = email === '';
  return (
    <form className={useStyles.root} onSubmit={handleSubmit}>
      <TextField
        name="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        type="text"
        placeholder="Email Address"
      />
      <Button
        variant="contained"
        color="primary"
        disabled={isInvalid}
        type="submit"
      >
        Reset My Password
      </Button>
      {error && <p>error.message</p>}
    </form>
  );
};

const PasswordForgetLink = () => (
  <Grid item xs>
    <Link variant="body2" to={ROUTES.PASSWORD_FORGET}>
      Forgot Password?
    </Link>
  </Grid>
);

export default PasswordForgetPage;

export { PasswordForgetForm, PasswordForgetLink };
